export default __webpack_public_path__ + "static/index-banner-18f6d4c083cee06f108ed5579fafe73c.png";